import { TimeValue } from '../../data-objects'
import { FieldDefinition } from './field-definition'

export class TimeFieldDefinition extends FieldDefinition {
  constructor(field: TimeFieldDefinition) {
    super(field)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): any {
    const toReturn = new TimeValue()
    return toReturn
  }
}
